export const getVideoThumbnail = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video')
    video.src = URL.createObjectURL(file)
    video.crossOrigin = 'anonymous'
    video.muted = true
    video.playsInline = true

    video.addEventListener('loadeddata', () => {
      video.currentTime = 1
    })

    video.addEventListener('seeked', () => {
      const canvas = document.createElement('canvas')
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight

      const ctx = canvas.getContext('2d')
      if (ctx) {
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height)
        const thumbnailUrl = canvas.toDataURL('image/png')
        resolve(thumbnailUrl)
      } else {
        reject(new Error('Erro ao capturar thumbnail'))
      }

      URL.revokeObjectURL(video.src)
    })

    video.addEventListener('error', () => {
      reject(new Error('Erro ao carregar o vídeo'))
    })
  })
}
